import { Navbar, Container, Nav, NavDropdown, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { requestLogout } from "../../actions/authentication";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../routes";

function Header() {
  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(requestLogout());
  };

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return (
    <Navbar bg="light" expand="lg">
      <Container>
        <Navbar.Brand>
          <Nav.Link as={Link} to="/">
            <img
              src="/images/logo.png"
              className="d-inline-block align-top"
              alt="Arrendamientos La Casona logo"
            />
          </Nav.Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-end"
        ></Navbar.Collapse>
        <Navbar.Collapse className="justify-content-end">
          <Nav className="me-auto">
            <Nav.Link as={Link} to={AppRoutes.HOME}>
              Home
            </Nav.Link>
            <NavDropdown title="Propiedades" id="basic-nav-dropdown">
              <Nav.Link as={Link} to={AppRoutes.RENT}>
                Arrendar
              </Nav.Link>
              <Nav.Link as={Link} to={AppRoutes.BUY}>
                Comprar
              </Nav.Link>
            </NavDropdown>
            <Nav.Link as={Link} to={AppRoutes.REQUIREMENTS}>
              Requisitos
            </Nav.Link>
            <Nav.Link as={Link} to={AppRoutes.SERVICES}>
              Servicios
            </Nav.Link>
            <Nav.Link as={Link} to={AppRoutes.CONSIGN}>
              Consigna tu propiedad
            </Nav.Link>
            <Nav.Link as={Link} to={AppRoutes.ABOUT_US}>
              Nosotros
            </Nav.Link>
            <Nav.Link as={Link} to={AppRoutes.CONTACT_US}>
              Contactenos
            </Nav.Link>
            {!isAuthenticated && (
              <Nav.Link as={Link} to={AppRoutes.LOGIN}>
                Login
              </Nav.Link>
            )}
            {isAuthenticated && <Button onClick={logoutHandler}>Logout</Button>}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
